<template>
    <div>
        <v-container fluid pa-0>
            <v-row align="center" justify="center" style="height:100vh" dense>
                <v-col cols="12" lg="6" md="6" class="fill-height d-flex flex-column justify-center align-center">
                    <v-card elevation="4" style="border-radius:10px">

                        <v-list style="background-color:#0f9750">
                            <v-list-item>
                                <v-list-item-action>
                                    <v-list-item-title class="unauthorized">Session Timeout</v-list-item-title>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>

                        <v-card-text>
                            <v-card-subtitle class="title_content">Your payment session has expired for the following reasons</v-card-subtitle>
                            <v-list-item style="margin-top:-15px">
                                <v-list-item-content>
                                    <v-list-item-title class="unauthorized_text"><span> &#8226;</span> Session time has expired.</v-list-item-title>
                                    <v-list-item-title class="unauthorized_text"><span> &#8226;</span> Token has expired or is invalid.</v-list-item-title>
                                    <v-list-item-title class="unauthorized_text"><span> &#8226;</span> Please return and try the payment again.</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>

                        <div style="margin-top:10px;margin-bottom:20px;padding-left:16px;padding-right:16px">
                            <v-row justify="center">
                                <v-col cols="12" md="8" class="d-flex flex-column align-center">
                                    <v-btn
                                        color="#0f9750"
                                        dark
                                        rounded
                                        :loading="returning"
                                        :disabled="returning"
                                        @click="returnToMerchant"
                                    >
                                        Return
                                    </v-btn>
                                    <p v-if="errorText" class="return-error">{{ errorText }}</p>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card>

                </v-col> 
            </v-row>
        </v-container>
    </div>
</template>


<style scoped>
    .unauthorized{
        font-size: 22px !important;
        color:#fff;
        font-weight: bold;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
        font-style:normal;
    }
    .unauthorized_text{
        font-size: 16px !important;
        color: #000000;
        font-weight: normal;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
        font-style:normal;
    }
    .title_content{
        font-size: 20px !important;
        color: #000000;
        font-weight: bold;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
        font-style:normal;
        margin-top:-15px;
    }
    .return-error{
        margin-top: 12px;
        margin-bottom: 0;
        color: #c62828;
        font-size: 14px;
        text-align: center;
        font-family: Calibri, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif;
    }
</style>


<script>
import axios from "axios";

export default {
    
    props: {
        base_url: {
            default: "",
            type: String
        },
        sp_return_url: {
            default: "",
            type: String
        },
        sp_orderid: {
            default: "",
            type: String
        }
    },
    
    data: () => ({
        returning: false,
        errorText: ""
    }),

    methods:{

        buildRedirectUrl(base) {
            const orderId = this.sp_orderid || "";
            if (!base) {
                return "";
            }
            const separator = base.includes("?") ? "&" : "?";
            return base + separator + "order_id=" + encodeURIComponent(orderId);
        },

        returnToMerchant(){
            this.errorText = "";
            this.returning = true;

            if (this.sp_return_url) {
                window.location.href = this.buildRedirectUrl(this.sp_return_url);
                return;
            }

            const orderId = this.sp_orderid;
            if (!orderId) {
                this.returning = false;
                this.errorText = "Order id missing. Unable to return.";
                return;
            }

            if (!this.base_url) {
                this.returning = false;
                this.errorText = "Return URL is not configured.";
                return;
            }

            // Public cancel endpoint (no JWT) — returns merchant return_url when prefer_return=1
            axios
                .request({
                    method: "POST",
                    url: this.base_url + "cancel",
                    data: {
                        order_id: orderId,
                        prefer_return: 1
                    }
                })
                .then((response) => {
                    if (response.data && response.data.message == 1 && response.data.url) {
                        window.location.href = response.data.url;
                        return;
                    }
                    this.returning = false;
                    this.errorText = "Unable to redirect. Please try again.";
                })
                .catch(() => {
                    this.returning = false;
                    this.errorText = "Unable to redirect. Please try again.";
                });
        }

    }
}
</script>
